#@import Hogan
#@export DealCarousel.CarouselTemplate

window.DealCarousel ?= {}
DealCarousel.CarouselTemplate = Hogan.compile '''
{{# renderFullCarousel }}
  <div class="gallery {{ classes }}" data-bhw="PromNightGallery" data-bhc="PromNightGallery:{{ uuid }}">
    <div class="gallery-featured">
      <div class="click-blocker"></div>
      {{# featured }}
        {{# isVideo }}
          <img src="http://cdnapi.kaltura.com/p/1302621/thumbnail/entry_id/{{ media }}/height/{{ collection.view.options.mediaHeight}}" id="gallery-video-{{ id }}" data-id="{{ id }}" />
        {{/ isVideo }}
        {{^ isVideo }}
          <img src="{{ media }}" id="gallery-image-{{ id }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />
        {{/ isVideo }}
      {{/ featured }}
    </div>

    {{# showThumbs }}
      <ul class="gallery-thumbs">
        {{# models }}
          <li class="gallery-thumbnail{{# isFeatured }} selected{{/ isFeatured }}{{# isVideo }} video{{/ isVideo }}{{^ thumb }} no-thumbnail{{/ thumb }}{{# isLast }} last{{/ isLast }}" id="gallery-thumb-{{ id }}" data-id="{{ id }}" data-bhc="thumbnail_click:{{ id }}"{{# isVideo }} data-bhd="{{ videoBHD }}"{{/ isVideo }}>
            {{# thumb }}
              {{# lazyLoadThumbs }}<img class="lazy-load" data-original="{{ thumb }}" />{{/ lazyLoadThumbs }}
              {{^ lazyLoadThumbs }}<img src="{{ thumb }}" />{{/ lazyLoadThumbs }}
            {{/ thumb }}
          </li>
        {{/ models }}
      </ul>
    {{/ showThumbs }}

    <div class="gallery-controls">
      {{# showProductSizing }}
        <div class="tangiblee-btn-groupon" data-bhw="TangibleeButton">
          <div class="compare-size-background"></div>
          <div class="compare-size-icon"></div>
          <div class="compare-size-text">{{ compareSizeMessage }}</div>
        </div>
      {{/ showProductSizing }}

      {{# showThumbs }}
        <div class="gallery-control-back icon-arrow-left-large disabled" data-bhc="thumbnail_back:{{ uuid }}"></div>
        <div class="gallery-control-forward icon-arrow-right-large" data-bhc="thumbnail_forward:{{ uuid }}"></div>
      {{/ showThumbs }}

      <div class="gallery-control-left icon-arrow-left-large disabled" data-bhc="bumper_left:{{ uuid }}"></div>
      <div class="gallery-control-right icon-arrow-right-large" data-bhc="bumper_right:{{ uuid }}"></div>
    </div>
  </div>
{{/ renderFullCarousel }}
{{^ renderFullCarousel }}
  <div class="gallery-single">
    <div class="gallery-featured">
      {{# first }}

         {{# lazyLoadFeatured }} <img class="featured-image sleepy-load" data-original="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} /> {{/ lazyLoadFeatured }}
         {{^ lazyLoadFeatured }} <img class="featured-image" src="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} /> {{/ lazyLoadFeatured }}

      {{/ first }}
    </div>
    <div class="gallery-controls">
      {{# showProductSizing }}
        <div class="tangiblee-btn-groupon" data-bhw="TangibleeButton">
          <div class="compare-size-background"></div>
          <div class="compare-size-icon"></div>
          <div class="compare-size-text">{{ compareSizeMessage }}</div>
        </div>
      {{/ showProductSizing }}
    </div>
  </div>
{{/ renderFullCarousel }}
'''
